import { HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Message } from 'primeng/api';
import { ExceptionDto } from '../api/dto/exception/exception-dto';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class ErroService {

    constructor(private router: Router,
        private activatedRoute: ActivatedRoute) { }

    handleErro(erro: any): Message[] {
        const message: Message[] = [];
        if (erro.status == HttpStatusCode.BadRequest) {
            if (erro.error) {
                const excecoes: ExceptionDto[] = erro.error;
                console.log(excecoes);
                for (const ex of excecoes) {
                    const requestId = ex.requestId;
                    for (const data of ex.data) {
                        message.push({ severity: 'warn', summary: data.message, detail: '' });
                    }
                }

            } else {
                message.push({ severity: 'error', summary: 'Houve um erro não identificado no sistema' ,
                     detail: erro.name });
            }
            

        }
        if (erro.status == HttpStatusCode.Unauthorized) {
            this.router.navigate(["/auth/login"], { relativeTo: this.activatedRoute });
        }
        if (erro.status == HttpStatusCode.NotFound) {
            message.push({ severity: 'warn', summary: 'Não Encontrado', detail: 'Nenhum Registro Encontrado' });
        }
        if (erro.status == HttpStatusCode.InternalServerError) {
            message.push({ severity: 'error', summary: 'Erro Interno no Servidor', detail: erro.message });
        }
        if (erro.status == 0) {
            message.push({ severity: 'error', summary: 'Ocorreu um erro inesperado. Requisição não realizada',
                 detail: erro.message });
        }
        return message;
    }

    handleSuccess(): Message[] {
        return [{ severity: 'success', summary: 'Sucesso', detail: 'Operação realizada com sucesso' }];
    }

}